import { forwardRef, Fragment, useEffect, useImperativeHandle } from "react";
import { Button, Col, Form, Input, Row, Select, Tooltip } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { DASHBOARD_LOTTOS } from "../../../../../constants/AppConstants";

const { TextArea } = Input;
const { Option } = Select;

const LottoBonuses = forwardRef((props, ref) => {
  const { visible, data, onUpdate, isEdit } = props;
  const [form] = Form.useForm();


  useImperativeHandle(ref, () => ({
    validate: () => form.validateFields(),
    getValue: () => form.getFieldsValue(),
  }));


  useEffect(() => {
    if (visible) {
      if (isEdit && data) {
        form.setFieldsValue({ bonuses: data.bonuses });

      } else if (!data) {
        form.resetFields();
      }
    } else {
      form.resetFields();
    }
  }, [visible, data, isEdit, form]);


  const handleChange = () => {
    const values = form.getFieldsValue();
    onUpdate({ ...data, bonuses: values.bonuses });
  };


  return (
    <Form
      form={form}
      layout="vertical"
      onValuesChange={handleChange}
    // initialValues={{ bonuses: data.bonuses }}
    >
      <Form.List name="bonuses">
        {(fields, { add, remove }) => (
          <Fragment>
            {fields.map(({ key, name, ...restField }) => (
              <Row key={key} gutter={16}>
                <Col className="px-5" xs={24} sm={12} md={3}>
                  <Form.Item
                    {...restField}
                    label={DASHBOARD_LOTTOS.BONUSES.COLUMNS.ID}
                    name={[name, "bonusId"]}
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col className="px-5" xs={24} sm={12} md={6}>
                  <Form.Item
                    {...restField}
                    label={DASHBOARD_LOTTOS.BONUSES.COLUMNS.BONUS}
                    name={[name, "bonus"]}
                    rules={[{ required: true, message: "Bonus requerido" }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col className="px-5" xs={24} sm={8} md={8}>
                  <Form.Item
                    {...restField}
                    label={DASHBOARD_LOTTOS.BONUSES.COLUMNS.BONUS_CONDITION}
                    name={[name, "bonusCondition"]}
                    rules={[{ required: true, message: "Condición requerida" }]}
                  >
                    <TextArea />
                  </Form.Item>
                </Col>
                <Col className="px-5" xs={24} sm={8} md={6}>
                  <Form.Item
                    {...restField}
                    label={DASHBOARD_LOTTOS.BONUSES.COLUMNS.CATEGORY}
                    name={[name, "category"]}
                    rules={[{ required: true, message: "Categoría requerida" }]}
                  >
                    <Select>
                      <Option value="Super Bono">Super Bono</Option>
                      <Option value="Extra Bono">Extra Bono</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col
                  className="px-5"
                  xs={24}
                  sm={8}
                  md={1}
                  style={{ alignContent: "center", textAlign: "center" }}
                >
                  <Tooltip title={DASHBOARD_LOTTOS.BONUSES.ACTIONS.DELETE}>
                    <Button
                      shape="circle"
                      icon={<DeleteOutlined />}
                      type="primary"
                      danger
                      onClick={() => {
                        remove(name);
                      }}
                    />
                  </Tooltip>
                </Col>
              </Row>
            ))}
            <Button
              type="dashed"
              onClick={() => add()}
              block
              icon={<PlusOutlined />}
            >
              {DASHBOARD_LOTTOS.BONUSES.ACTIONS.ADD}
            </Button>
          </Fragment>
        )}
      </Form.List>
    </Form>
  );
});

export default LottoBonuses;
